import { Maybe } from "./types/maybe.ts";

export default function dateStringComparer(
  a: Maybe<string>,
  b: Maybe<string>,
): number {
  if (a == null) {
    return 1;
  }

  if (b == null) {
    return -1;
  }

  return b.localeCompare(a);
}
